module.exports = __webpack_public_path__ + "img/graph-medium.c7521cc1.svg";